<template>
  <div>
    <PopUpInputTable
      v-model="showPopUp"
      :col="col"
      :row="row"
      :rowObjetivoPartida="rowObjetivoPartida"
      :type="type"
      @saveDato="saveDato"
    />

    <div class="divTable">
      <div class="row divHeader">
        <div class="col-5">{{ col }}</div>
        <div class="col-5">Fecha</div>
        <div class="col-2"></div>
      </div>
      <div class="row divBody">
        <div class="col-5">{{ row.dato }}</div>
        <div class="col-5">{{ row.fecha }}</div>
        <div v-if="!isOnlyAccess" class="col-2">
          <q-icon
            name="o_create"
            style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
            @click="changeShowPopUp()"
          />
        </div>
      </div>
    </div>
    <div v-if="!isManual" class="divObligatorio">*Campo obligatorio</div>
  </div>
</template>
<script>
import PopUpInputTable from '@/components/PlanAccion/components/PopUpInputTable.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    PopUpInputTable
  },
  props: {
    col: String,
    row: Object,
    rowObjetivoPartida: Object,
    type: String,
    isManual: Boolean
  },
  computed: {
    ...mapGetters({
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  data () {
    return {
      showPopUp: false
    };
  },
  methods: {
    changeShowPopUp () {
      this.showPopUp = true;
    },
    saveDato (newDato) {
      this.row.dato = newDato.dato;
      this.row.fecha = newDato.fecha;
      let datos = { dato: newDato.dato, fecha: newDato.fecha };
      this.$emit('updateDatosPartidaYObjetivo', datos);
    }
  }
};
</script>
<style lang="scss" scoped>
.divTable {
  border-radius: 5px;
  border: solid 2px grey;
  margin: 0px;
  margin-top: 30px;
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  .divHeader {
    border-bottom: solid 2px grey;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.11px;
    color: #002f6c;
    padding: 10px;
  }
  .divBody {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.12px;
    color: #2b2a2a;
    padding: 10px;
    height: 97px;
    align-content: center;
  }
}
.divObligatorio {
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.16px;
  color: grey !important;
}
</style>
